module.exports = __webpack_public_path__ + "static/media/23.75e97b19.jpg";